import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BatchRequirementService } from '@services/bathupdaterequirement.service';
import { CustomfieldsService } from '@services/customfields.service';
import { RequirementTypesService } from '@services/requerimenttypes.service';
import { ResponseObjectAPI } from 'src/app/models/responseObjectAPI';
import { RequirementService } from 'src/app/services/requirement.service';

@Component({
    selector: 'batch-change-state-requirement-dialog',
    templateUrl: './batch-change-state-requirement-dialog.component.html',
    styleUrls: ['./batch-change-state-requirement-dialog.component.scss'],
    standalone: false
})


export class BatchChangeStatusRequirementDialogComponent implements OnInit {



  returning = false;
  form = new FormGroup({
		commentArea: new FormControl('')
  });

  @Input() requirementIds;
  @Output() returned = new EventEmitter();
  @Input() userId: null;
  customfieldsRequirementType: any[] = [];
  visibilityId: number;
  states:[];
  resultCustomfieldsSubGrop: any;
  isSubGrupo:boolean = false;
  statususers?: any;

  constructor(
    public activeModal: NgbActiveModal,
    public requirementService: RequirementService,
    public requirementTypesService:RequirementTypesService,
    private batchRequirementService:BatchRequirementService,
    private _customfields: CustomfieldsService
    ) { }

    isValidate: boolean = false;
    requirementFieldsValuePreview: {} = {};
    actionid:number;
    isSubmitting = false;



    async ngOnInit() {
      this.userId = null;
      this.resultCustomfieldsSubGrop = this._customfields.filterArray(this.customfieldsRequirementType, 'type', 48,'===');
      this.isSubGrupo = this.resultCustomfieldsSubGrop.length > 0 ? true : false;

      const body = {
        requirementids: this.requirementIds
      };
      this.isValidate = true;

      this.batchRequirementService.getActionStatus(body).subscribe((resp:any) => {
        this.states= resp.result.data;
     });

      this.requirementService.getRequirementAllData(this.requirementIds[0]).subscribe((resp: any) => {
      });
    }


  onSubmit(requirementFields) {
    const formData: FormData = new FormData();
    formData.append("requirementids", JSON.stringify(this.requirementIds));
    formData.append("actionid", this.actionid.toString());
    formData.append("userid", this.userId);
    formData.append("fields", JSON.stringify(requirementFields));

    this.batchRequirementService.changeStatusRequirement(formData).subscribe(
      (resp: ResponseObjectAPI) => {
        this.returned.emit(true);
        this.activeModal.close();
      },
      (error) => {
        this.isSubmitting = false;
        this.returning = false;
      }
    );
  }

  getCustomfieldsValues(event: { valid: boolean; value: {} }) {
    this.isValidate = event.valid;
    this.requirementFieldsValuePreview = event.value;
  }


  onValueStateChange(value){

    let code = value.split("-");


    let body = {
      requirementtypeid: code[2],
      statusid: code[0],
    };

    this.actionid= code[1];



    this.batchRequirementService.getCustomFieldByRequirementTypeIdAndStatuId(body).subscribe((resp: ResponseObjectAPI) => {
      this.customfieldsRequirementType = resp.result.map((field: any) => {
        if (field.values) {
          field.values = JSON.parse(field.values);
        }
        if(field.actionid){
          this.actionid=field.actionid;
        }
        return field;
      });
    });

    const bodyActions = {
      requirementtypeid: code[2],
      actionid: code[1],
    };


    this.batchRequirementService.getActionsByTypeRequirement(bodyActions).subscribe((resp:any) => {
      this.statususers=resp.result.actionsbyrequirementtype[0];
      console.log("Aca",this.statususers);
    });


  }

  async saveDataToChangeStatus() {
    if (this.isSubmitting) return;

    try {
      this.isSubmitting = true;
      this.returning = true;
      const requirementFields = [];
      const idsTypeArray = [];
      const reqArrayType = [];
      Object.entries(this.requirementFieldsValuePreview).forEach(
        (customField) => {
          if (this.isJsonArray(customField[1])) {
            // store all ids
            customField[1] = this._customfields.parseCustomfielsMultiple(customField[1]);
            idsTypeArray.push(customField[0]);
            delete customField[1][0].data;
            reqArrayType.push({
              id: customField[0],
              value: customField[1],
            });
          } else {
            // store only objects that are not array
            switch (typeof customField[1]) {
              case "string":
                if(customField[1]){
                  requirementFields.push({
                    id: customField[0],
                    value: customField[1].replace('%','').replace(',','.'),
                  });
                }
                break;
              case "object":
                if(customField[1]){
                  requirementFields.push({
                    id: customField[0],
                    value: JSON.stringify(customField[1]),
                  });
                }
                break;
              case "number":
              case "boolean":
                requirementFields.push({
                  id: customField[0],
                  value: customField[1].toString(),
                });
                break;
            }
          }
        }
      );
      // create a variable to store final arrys
      let uniqueArrays = [];
      // con el array de ids recolectados se realiza un match con los arrys que tiene objectos
      // para si poder solo mantener un solo id y no repetidos.
      // tslint:disable-next-line: forin  [insert first value ]
      for (const reFields in reqArrayType) {
        for (const id in idsTypeArray) {
          if (reqArrayType[reFields].id === idsTypeArray[id]) {
            const existArray = uniqueArrays.find(
              (v) => v.id === idsTypeArray[id]
            );
            if (!existArray) {
              uniqueArrays.push(reqArrayType[reFields]);
              reqArrayType.splice(
                reqArrayType.findIndex((v) => v.id === idsTypeArray[id]),
                1
              );
            }
          }
        }
      }
      // Insert rest values into unique arrays
      // en esta etapa tenemos los arrays de esta forma [{id: 408, value: Prueba1 }]
      // y aqui vamos a adjunta el objecto additionalFields.
      // tslint:disable-next-line: forin
      for (const rq in reqArrayType) {
        for (const ua in uniqueArrays) {
          if (uniqueArrays[ua].id === reqArrayType[rq].id) {
            // tslint:disable-next-line: forin
            for (const vu in uniqueArrays[ua].value) {
              // tslint:disable-next-line: forin
              for (const vrq in reqArrayType[rq].value) {
                if (
                  reqArrayType[rq].value[vrq].motivo ===
                  uniqueArrays[ua].value[vu].value
                ) {
                  Object.assign(uniqueArrays[ua].value[vu], {
                    additionalFields: {
                      motivo: reqArrayType[rq].value[vrq].motivo,
                      tipoMoneda: reqArrayType[rq].value[vrq].tipoMoneda,
                      montoMulta: reqArrayType[rq].value[vrq].montoMulta,
                    },
                  });
                }
              }
            }
          }
        }
      }
      // una vez ya teniendo los arrys vamos adjuntar con los objectos en un solo array
      // insert into requirementFields
      for (const ua of uniqueArrays) {
        requirementFields.push({
          id: ua.id,
          value: JSON.stringify(ua.value),
          temporaryfilesids: [],
        });
      }
      //parse the data of the subgroups and send individually
      if(this.resultCustomfieldsSubGrop.length > 0){
        let extractSubGroup;
        const listIds = requirementFields.map(el => el.id);
        this.resultCustomfieldsSubGrop.forEach(element => {
          extractSubGroup = this._customfields.extractData(requirementFields, element.id);
          extractSubGroup.forEach((e, index) => {
            if(listIds.includes(String(index))){
              requirementFields[String(listIds.indexOf(String(index)))].value = JSON.stringify(e);
            }else{
              requirementFields.push({id: String(index), value: JSON.stringify(e)});
            }
          });
        });
      }
      this.onSubmit(requirementFields);
    } catch (error) {
      this.isSubmitting = false;
      this.returning = false;
    }
  }

  isJsonArray(str: unknown) {
    try {
      if (Array.isArray(str)) {
        return true;
      }
    } catch (e) {
      return false;
    }

    return false;
  }

  onValueUserChange(value){
    this.userId = value
  }

}
